import { jsx as _jsx } from "react/jsx-runtime";
import { FontAwesomeIcon, maeArrowToLeft, maeArrowToRight } from '@mae/icons/base-icons';
import { useTheme } from '@mui/material';
export function AutoCollapseIcon({ isOn, isRtl }) {
    const theme = useTheme();
    return (_jsx(FontAwesomeIcon, { color: isOn ? theme.palette.secondary.main : undefined, size: "xs", icon: isRtl ? maeArrowToRight : maeArrowToLeft }));
}
